import TreeRow from './TreeRow';
import { TreeContext } from "../../../utils/contexts";
const { List } = window.Material;

export default class Tree extends React.PureComponent {
  render() {
    const { currentSite, treeItems } = this.context;

    return (
      <List>
        <TreeRow
          item={{
            nodeRef: currentSite.nodeRef,
            name: currentSite.label,
            hasChildren: true,
          }}
          level={0}
          treeItems={treeItems}
        />
      </List>
    );
  }
}

Tree.contextType = TreeContext;
